"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAdobeAnalyticsConfirmationPage = exports.generateAdobeAnalyticsPaymentRequest = exports.generateAdobeAnalyticsSearchPasses = exports.generateAdobeAnalyticsSearchResultItemsCount = exports.generateAdobeAnalyticsSessionInitEvent = exports.generateAdobeAnalyticsNewsletterSubscribeEvent = exports.generateAdobeAnalyticsSetSearchTerm = exports.generateAdobeAnalyticsSearchEventProduct = exports.generateAdobeAnalyticsDeliveryPromiseEvent = exports.generateAdobeAnalyticsToggleComparePopup = exports.generateAdobeAnalyticsCloseComparePopup = exports.generateAdobeAnalyticsOpenComparePopup = exports.generateAdobeAnalyticsComparePageProductDisplayedToggle = exports.generateAdobeAnalyticsComparePageProductDisplayed = exports.generateAdobeAnalyticsComparePageNoProductDisplayed = exports.generateAdobeAnalyticsOpenComparePage = exports.generateAdobeAnalyticsCompareEvent = exports.generateAdobeAnalyticsWishlistEvent = exports.generateAdobeAnalyticsFredhopperSegment = exports.generateAdobeAnalyticsListerProductClick = exports.generateGoogleAnalyticsCookieConsentTriggers = exports.generateAdobeAnalyticsCookieConsentTriggers = exports.generateAdobeAnalyticsProductDetailImpression = exports.generateFormErrorMessageDigitalDataObject = exports.generateDigitalPartnerEnrolmentDigitalDataObject = exports.generateAdobeAnalyticsSetAddBundleToBasketEvent = exports.generateAdobeAnalyticsSetBasketToken = exports.generateAdobeAnalyticsSetAddToBasketLocation = exports.generateAdobeAnalyticsConfirmationPageEvent = exports.generateAdobeAnalyticsBasketChangeEvent = exports.generateGoogleAnalyticsTransactionDataEvent = exports.generateGoogleAnalyticsCheckoutStepEvent = exports.generateGoogleAnalyticsCheckoutOptionEvent = exports.generateGoogleAnalyticsSizePickedEvent = exports.generateGoogleAnalyticsProductDetailEvent = exports.generateGoogleAnalyticsBasketEvent = exports.generateAdobeAnalyticsFilterFacetImpression = exports.generateAdobeAnalyticsSetPartialSearchResults = exports.generateAdobeAnalyticsProductSearchImpressionEvent = exports.generateGoogleAnalyticsProductImpressionEvent = exports.generateCriteoImpressionEventFromConfirmation = exports.generateCriteoProductImpressionEventFromBasketProducts = exports.generateCriteoProductIdsFromBasketProducts = exports.generateCriteoProductImpressionEvent = exports.generateCriteoImpressionEvent = exports.generateCriteoBasketData = exports.generateCriteoProductId = exports.generateCriteoUserData = exports.generateCriteoProductIds = exports.generateAdobeAnalyticsAdditionalProductList = void 0;
exports.generateAdobeAnalyticsAdditionalProductSelector = exports.generateBasketReminderNotificationEvent = exports.generateBasketReminderNotificationViewed = exports.generateAdobeAnalyticsGiftVoucherInit = exports.generateAdobeAnalyticApplePayButtonImpression = exports.generateAdobeAnalyticApplePayButtonInitialInViewport = exports.generateAdobeAnalyticsProductVariantClick = exports.generateAdobeAnalyticsProductGroupItemClick = exports.generateAdobeAnalyticsProductGroupViewed = exports.generateAdobeAnalyticsPaybackError = exports.generateGoogleAnalyticsPaybackError = exports.generateAdobeAnalyticsEnrichmentChanged = exports.generateGoogleAnalyticsPaybackEnrichmentChanged = exports.generateAdobeAnalyticsFaqQuestionExpand = exports.generateAdobeAnalyticsNotifyMeObject = exports.generateAdobeAnalyticsBundleDealsViewedObject = exports.generateGoogleCustomerIdentityAction = exports.generateGoogleAnalyticsListerViewProductListEvent = exports.generateAdobeAnalyticsListerResults = exports.generateAdobeAnalyticsProductDetailAddToBasket = exports.generateAdobeAnalyticsProductDetailSizeGuideClick = exports.generateAdobeAnalyticsProductDetailInit = exports.generateAdobeAnalyticsProductDetailTabOpen = exports.generateAdobeAnalyticsShowStoreStock = exports.generateAdobeAnalyticsReturnPortalEvent = exports.generateAdobeAnalyticsReturnPortalOverview = exports.generateAdobeAnalyticsReturnPortalLogin = exports.generateAdobeAnalyticsNewsletterPreferencesUpdateEvent = exports.generateAdobeAnalyticsNewsletterPreferencesSubscriptionUpdateEvent = exports.generateAdobeAnalyticsListerSortChangeEvent = exports.generateAdobeAnalyticsShopTheLook = exports.generateAdobeAnalyticsProductSearchPersonalization = exports.generateAdobeAnalyticsCompareProductsFeatures = exports.generateAdobeAnalyticsCheckoutType = exports.generateAdobeAnalyticsFilterWizardEvent = exports.generateAdobeAnalyticsEventObjectV2 = exports.generateAdobeAnalyticsEventObject = exports.generateAdobeAnalyticsVoucherAdded = exports.generateAdobeAnalyticsFastCheckoutStep = exports.generateAdobeAnalyticsPaymentStep = exports.generateAdobeAnalyticsDeliveryStep = exports.generateAdobeAnalyticsRegistrationStep = exports.generateGoogleAnalyticsPaymentStepOption = exports.generateGoogleAnalyticsPaymentStep = exports.generateGoogleAnalyticsDeliveryStepOption = exports.generateGoogleAnalyticsDeliveryStep = exports.generateAdobeAnalyticsCheckout = void 0;
const common_types_1 = require("@as-react/common-types");
const common_utils_1 = require("@as-react/common-utils");
const CompareConstants_1 = require("../constants/CompareConstants");
const ActionEnums_1 = require("../enums/ActionEnums");
const AnalyticsEnums_1 = require("../enums/AnalyticsEnums");
const AnalyticsActions_interfaces_1 = require("../redux/analytics/actions/AnalyticsActions.interfaces");
const SessionStorageUtil_1 = require("./SessionStorageUtil");
const SearchConstants_1 = require("../constants/SearchConstants");
const formik_1 = require("formik");
const DateUtil_1 = require("../util/DateUtil");
const GeneralConstants_1 = require("../constants/GeneralConstants");
const filterProductsFromListerItems = (listerItems) => listerItems.filter(item => (0, common_types_1.isProduct)(item));
const convertListerItemToProductImpression = (listerItems, opts) => listerItems.filter(common_types_1.isProduct).map((productItem, index) => {
    const selectedColorVariation = (0, common_utils_1.findColor)(productItem.colours, productItem.colourId);
    return Object.assign(Object.assign(Object.assign(Object.assign({}, productItem.impression), { colourId: selectedColorVariation.colourId, colourCode: selectedColorVariation.colourCode }), (Boolean(opts === null || opts === void 0 ? void 0 : opts.withQuantity) && { quantity: 1 })), (Boolean(opts === null || opts === void 0 ? void 0 : opts.withPosition) && { position: index + 1 }));
});
const objectToString = (object) => Object.keys(object).join(',');
const subscriptionsObjectToString = (preferences) => Object.keys(preferences)
    .filter(key => Boolean(preferences[key]))
    .join(',');
const generateAdobeAnalyticsBundleProduct = (product, bundleProductType) => {
    var _a;
    const selectedColor = product.colours[0];
    const selectedSize = (0, common_utils_1.findSizeBySku)(selectedColor.sizes, (0, common_utils_1.determineSelectedSku)(selectedColor));
    const activeProductPrice = (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.prices) || selectedColor.prices;
    return {
        attributes: {
            sellPrice: (_a = activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.SELL) === null || _a === void 0 ? void 0 : _a.original,
            RRPSTD: (activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.RRP)
                ? activeProductPrice.RRP.original
                : (activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.STD)
                    ? activeProductPrice.STD.original
                    : (activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.SELL)
                        ? activeProductPrice.SELL.original
                        : undefined,
            brand: product.brand,
            productRating: product.productRating,
            productReviews: product.productReviews,
            productImages: selectedColor.image ? 1 : 0,
            bundleProductType,
        },
        productInfo: {
            productID: product.productId,
            colorId: selectedColor,
            color: selectedColor.description,
            size: selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.originalSize,
            colorCode: selectedColor.colourCode,
        },
    };
};
const generateAdobeAnalyticsAdditionalProductList = (additionalProducts) => additionalProducts.map(additionalProduct => {
    var _a;
    const { displayedColor, product } = additionalProduct;
    const selectedSize = (0, common_utils_1.findSizeBySku)(displayedColor.sizes, (0, common_utils_1.determineSelectedSku)(displayedColor));
    const activeProductPrice = (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.prices) || displayedColor.prices;
    return {
        attributes: {
            sellPrice: (_a = activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.SELL) === null || _a === void 0 ? void 0 : _a.original,
            RRPSTD: (activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.RRP)
                ? activeProductPrice.RRP.original
                : (activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.STD)
                    ? activeProductPrice.STD.original
                    : (activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.SELL)
                        ? activeProductPrice.SELL.original
                        : undefined,
            brand: product.brand,
            productRating: product.productRating,
            productReviews: product.productReviews,
            productImages: displayedColor.image ? 1 : 0,
            additionalProductBundle: 'Additional',
        },
        productInfo: {
            productID: product.productId,
            colorId: displayedColor,
            color: displayedColor.description,
            colorCode: displayedColor.colourCode,
        },
    };
});
exports.generateAdobeAnalyticsAdditionalProductList = generateAdobeAnalyticsAdditionalProductList;
const generateProductGroupImpression = (product, productTilePosition) => {
    var _a, _b;
    const activeColor = (0, common_utils_1.getDefaultProductColor)(product);
    return {
        productInfo: {
            productID: product.productId,
            colorCode: activeColor === null || activeColor === void 0 ? void 0 : activeColor.colourCode,
            color: activeColor === null || activeColor === void 0 ? void 0 : activeColor.description,
        },
        attributes: {
            sellPrice: (_b = (_a = activeColor === null || activeColor === void 0 ? void 0 : activeColor.prices) === null || _a === void 0 ? void 0 : _a.SELL) === null || _b === void 0 ? void 0 : _b.original,
            brand: product.brand,
            productTilePosition,
        },
    };
};
const generateAdobeAnalyticsBundleProductList = (bundleSlots) => bundleSlots.flatMap(slot => slot.bundleChildren.flatMap((child, index) => generateAdobeAnalyticsBundleProduct(child, index === 0 ? 'Child' : 'Alternative')));
const getSelectedColorForProduct = (product) => { var _a; return (_a = product.productColorVariations) === null || _a === void 0 ? void 0 : _a.find(color => color.colorId === product.selectedColorId); };
const getSelectedSizeForProduct = (product) => {
    const selectedColor = getSelectedColorForProduct(product);
    if (selectedColor) {
        return selectedColor.sizes.find(size => size.sku === product.selectedSku);
    }
    return undefined;
};
const generateCriteoProductIds = (listerItems) => {
    const productItems = filterProductsFromListerItems(listerItems);
    const firstThreeProducts = productItems.length > 3 ? productItems.slice(0, 3) : productItems;
    return { ProductID: firstThreeProducts.map(product => product.productId) };
};
exports.generateCriteoProductIds = generateCriteoProductIds;
const userIsLoggedInHelper = (session) => { var _a, _b; return session.authorities && ((_b = (_a = session.authorities) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.authority) !== common_types_1.SessionAuthorityTypes.ANONYMOUS && !!session.amcUuid; };
const generateCriteoUserData = (payload) => ({
    HashedEmail: userIsLoggedInHelper(payload) ? payload.amcUuid : 'anonymous',
});
exports.generateCriteoUserData = generateCriteoUserData;
const generateCriteoProductId = (productId) => ({ ProductID: productId });
exports.generateCriteoProductId = generateCriteoProductId;
const generateCriteoBasketData = (products) => ({
    ProductID: products.map(_product => ({
        id: _product.id,
        price: _product.price,
        quantity: _product.quantity,
    })),
});
exports.generateCriteoBasketData = generateCriteoBasketData;
const generateCriteoImpressionEvent = (baseWindowObjectName, additionalParams) => {
    const criteoPageObject = (0, common_utils_1.getCustomWindowObject)(baseWindowObjectName);
    const pageType = (0, common_utils_1.getCustomWindowObject)('SITE.Config.analyticsPageType');
    if (!(0, common_utils_1.isNullOrUndefined)(pageType) &&
        !(0, common_utils_1.isNullOrUndefined)(criteoPageObject) &&
        !(0, common_utils_1.isNullOrUndefined)(criteoPageObject.HashedEmail)) {
        const objectToSend = Object.assign(Object.assign(Object.assign({ TransactionID: undefined }, criteoPageObject), additionalParams), { event: 'criteodata', SiteType: /Mobi|Android/i.test(navigator.userAgent) ? 'm' : 'd', HashedEmail: criteoPageObject.HashedEmail === 'anonymous' ? '' : criteoPageObject.HashedEmail });
        switch (pageType) {
            case 'product':
            case 'cart':
            case 'brands':
            case 'search':
            case 'lister':
            case 'category':
                if (!(0, common_utils_1.isNullOrUndefined)(objectToSend.ProductID)) {
                    return objectToSend;
                }
                break;
            case 'purchase':
                if (!(0, common_utils_1.isNullOrUndefined)(objectToSend.ProductID) && !(0, common_utils_1.isNullOrUndefined)(objectToSend.TransactionID)) {
                    return objectToSend;
                }
                break;
            case 'home':
                return objectToSend;
            default:
                break;
        }
    }
    return null;
};
exports.generateCriteoImpressionEvent = generateCriteoImpressionEvent;
const generateCriteoProductImpressionEvent = (baseWindowObjectName, listerItems) => (0, exports.generateCriteoImpressionEvent)(baseWindowObjectName, (0, exports.generateCriteoProductIds)(listerItems));
exports.generateCriteoProductImpressionEvent = generateCriteoProductImpressionEvent;
const generateCriteoProductIdsFromBasketProducts = (products) => ({
    ProductID: products.slice(0, 3).map(product => product.productId),
});
exports.generateCriteoProductIdsFromBasketProducts = generateCriteoProductIdsFromBasketProducts;
const generateCriteoProductImpressionEventFromBasketProducts = (baseWindowObjectName, products) => {
    if (products) {
        (0, exports.generateCriteoImpressionEvent)(baseWindowObjectName, (0, exports.generateCriteoProductIdsFromBasketProducts)(products));
    }
};
exports.generateCriteoProductImpressionEventFromBasketProducts = generateCriteoProductImpressionEventFromBasketProducts;
const generateCriteoImpressionEventFromConfirmation = (baseWindowObjectName, payload) => {
    var _a;
    return (0, exports.generateCriteoImpressionEvent)(baseWindowObjectName, Object.assign({ TransactionID: (_a = payload.purchase.actionField) === null || _a === void 0 ? void 0 : _a.id }, (0, exports.generateCriteoBasketData)(payload.purchase.products)));
};
exports.generateCriteoImpressionEventFromConfirmation = generateCriteoImpressionEventFromConfirmation;
const generateGoogleAnalyticsProductImpressionEvent = (listerItems) => {
    const impressions = convertListerItemToProductImpression(listerItems !== null && listerItems !== void 0 ? listerItems : []);
    if (Array.isArray(impressions) && impressions.length > 0) {
        return {
            event: 'productImpression',
            ecommerce: impressions,
        };
    }
    return null;
};
exports.generateGoogleAnalyticsProductImpressionEvent = generateGoogleAnalyticsProductImpressionEvent;
const generateAdobeAnalyticsProductSearchImpressionEvent = (searchTerm) => {
    if (searchTerm && searchTerm !== '') {
        return {
            page: {
                pageInfo: {
                    onsiteSearch: searchTerm,
                },
            },
        };
    }
    return null;
};
exports.generateAdobeAnalyticsProductSearchImpressionEvent = generateAdobeAnalyticsProductSearchImpressionEvent;
const generateAdobeAnalyticsSetPartialSearchResults = () => ({
    page: {
        pageInfo: {
            partialResults: true,
        },
    },
});
exports.generateAdobeAnalyticsSetPartialSearchResults = generateAdobeAnalyticsSetPartialSearchResults;
const generateAdobeAnalyticsFilterFacetImpression = (activeFilters) => {
    const maxAmountFilters = 5;
    const maxAmountFilterValues = 3;
    if (activeFilters) {
        const filters = {};
        Object.keys(activeFilters).forEach((filterKey, filterIndex) => {
            var _a, _b, _c, _d, _e;
            if (((_a = activeFilters[filterKey]) === null || _a === void 0 ? void 0 : _a.filterType) === common_types_1.RANGE_FILTER &&
                !(0, common_utils_1.isNullOrUndefined)((_b = activeFilters[filterKey]) === null || _b === void 0 ? void 0 : _b.rangeMin) &&
                !(0, common_utils_1.isNullOrUndefined)((_c = activeFilters[filterKey]) === null || _c === void 0 ? void 0 : _c.rangeMax) &&
                filterIndex < maxAmountFilters) {
                filters[`type${filterIndex + 1}`] = filterKey;
                filters[`type${filterIndex + 1}Value1`] = `#${activeFilters[filterKey].rangeMin}#-#${activeFilters[filterKey].rangeMax}#`;
            }
            else if (((_e = (_d = activeFilters[filterKey]) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e.length) && filterIndex < maxAmountFilters) {
                filters[`type${filterIndex + 1}`] = filterKey;
                activeFilters[filterKey].values.forEach((filterValue, filterKeyIndex) => {
                    let filterName = filterValue.filterKeyName;
                    if (filterName.includes(GeneralConstants_1.FILTER_SIZE_SEPARATOR)) {
                        const [size, category] = filterName.split(GeneralConstants_1.FILTER_SIZE_SEPARATOR);
                        filterName = `${size}_${category}`;
                    }
                    if (filterKeyIndex < maxAmountFilterValues) {
                        filters[`type${filterIndex + 1}Value${filterKeyIndex + 1}`] = filterName;
                    }
                });
            }
        });
        return {
            page: { filters },
        };
    }
    return null;
};
exports.generateAdobeAnalyticsFilterFacetImpression = generateAdobeAnalyticsFilterFacetImpression;
const generateGoogleAnalyticsBasketEvent = (data) => (Object.assign(Object.assign({}, data), { ecommerce: Object.keys(data.ecommerce).reduce((accumulator, currentValue) => {
        let dataToAdd = {};
        if (data.ecommerce[currentValue] !== null &&
            !(currentValue === 'impressions' && data.ecommerce[currentValue].length === 0)) {
            dataToAdd = {
                [currentValue]: data.ecommerce[currentValue],
            };
        }
        return Object.assign(Object.assign({}, accumulator), dataToAdd);
    }, {}) }));
exports.generateGoogleAnalyticsBasketEvent = generateGoogleAnalyticsBasketEvent;
const generateGAProductTypeFromProductDetail = (product) => {
    var _a;
    const selectedColorVariation = getSelectedColorForProduct(product);
    return {
        brand: product.brand ? product.brand.description : null,
        category: product.category ? product.category.description : null,
        id: product.productId,
        name: product.productTranslatedProperties && 'title' in product.productTranslatedProperties
            ? product.productTranslatedProperties.title
            : '',
        price: (_a = selectedColorVariation.prices) === null || _a === void 0 ? void 0 : _a.SELL.original,
        variant: selectedColorVariation.color,
        colourId: selectedColorVariation.colorId,
        colourCode: selectedColorVariation.colorCode,
        productColorId: selectedColorVariation.productColorId,
        quantity: 1,
        skuId: product.selectedSku,
    };
};
const generateGoogleAnalyticsProductDetailEvent = (product, event, currency) => {
    return {
        event,
        ecommerce: Object.assign(Object.assign({}, (currency ? { currencyCode: (0, common_utils_1.getCurrencyISOCode)(currency) } : {})), { detail: {
                actionField: {
                    list: null,
                },
                products: [generateGAProductTypeFromProductDetail(product)],
            } }),
    };
};
exports.generateGoogleAnalyticsProductDetailEvent = generateGoogleAnalyticsProductDetailEvent;
const generateGoogleAnalyticsSizePickedEvent = (product, event) => {
    const selectedColor = getSelectedColorForProduct(product);
    return (0, common_utils_1.isOneSizeProduct)(selectedColor.sizes, (0, common_utils_1.getCustomWindowObject)('SITE.Config.product.code.oneSize'))
        ? null
        : (0, exports.generateGoogleAnalyticsProductDetailEvent)(product, event);
};
exports.generateGoogleAnalyticsSizePickedEvent = generateGoogleAnalyticsSizePickedEvent;
const generateGoogleAnalyticsCheckoutOptionEvent = (isNewCustomer) => ({
    event: 'checkoutOption',
    ecommerce: {
        checkout_option: {
            actionField: {
                step: 2,
                option: isNewCustomer ? 'New customer' : 'Existing customer',
            },
        },
    },
});
exports.generateGoogleAnalyticsCheckoutOptionEvent = generateGoogleAnalyticsCheckoutOptionEvent;
const generateGoogleAnalyticsCheckoutStepEvent = ({ step, option = '' }) => ({
    event: 'checkout',
    ecommerce: {
        checkout_option: {
            actionField: {
                step,
                option,
            },
        },
    },
});
exports.generateGoogleAnalyticsCheckoutStepEvent = generateGoogleAnalyticsCheckoutStepEvent;
const generateGoogleAnalyticsTransactionDataEvent = (data) => ({
    event: 'transactiondata',
    ecommerce: data,
});
exports.generateGoogleAnalyticsTransactionDataEvent = generateGoogleAnalyticsTransactionDataEvent;
const generateAdobeAnalyticsBasketChangeEvent = (data) => {
    var _a;
    let userData = {};
    let productData = {};
    let pageData = {};
    let cartData = {};
    let eventData = {};
    let componentData = {};
    if (data.user) {
        userData = {
            user: {
                attributes: {
                    newsletterOptin: (_a = data.user.attributes) === null || _a === void 0 ? void 0 : _a.newsletterOptin,
                },
            },
        };
    }
    if (data.product) {
        productData = {
            product: data.product,
        };
    }
    if (data.page && data.page.attributes) {
        pageData = {
            page: {
                attributes: Object.assign(Object.assign({}, (!!data.page.attributes.primaryCategory && {
                    primaryCategory: data.page.attributes.primaryCategory,
                })), (!!data.page.attributes.addCardLocation && {
                    addCardLocation: data.page.attributes.addCardLocation,
                })),
            },
        };
    }
    if (data.cart && data.cart.cartID) {
        cartData = {
            cartID: data.cart.cartID,
        };
    }
    if (data.event) {
        eventData = {
            event: data.event,
        };
    }
    if (data.component) {
        componentData = {
            component: data.component,
        };
    }
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, userData), productData), pageData), cartData), eventData), componentData);
};
exports.generateAdobeAnalyticsBasketChangeEvent = generateAdobeAnalyticsBasketChangeEvent;
const generateAdobeAnalyticsConfirmationPageEvent = (data) => {
    let productData = {};
    let pageData = {};
    let transactionData = {};
    let eventData = {};
    if (data.product) {
        productData = {
            product: data.product,
        };
    }
    if (data.page && data.page.attributes) {
        pageData = {
            page: {
                attributes: Object.assign({}, (!!data.page.attributes.primaryCategory && {
                    primaryCategory: data.page.attributes.primaryCategory,
                })),
            },
        };
    }
    if (data.transaction) {
        transactionData = {
            transaction: data.transaction,
        };
    }
    if (data.event) {
        eventData = {
            event: data.event,
        };
    }
    return Object.assign(Object.assign(Object.assign(Object.assign({}, productData), pageData), transactionData), eventData);
};
exports.generateAdobeAnalyticsConfirmationPageEvent = generateAdobeAnalyticsConfirmationPageEvent;
const generateAdobeAnalyticsSetAddToBasketLocation = (addToBasketLocation) => ({
    page: {
        attributes: {
            addCardLocation: addToBasketLocation,
        },
    },
});
exports.generateAdobeAnalyticsSetAddToBasketLocation = generateAdobeAnalyticsSetAddToBasketLocation;
const generateAdobeAnalyticsSetBasketToken = (token) => ({
    cart: {
        cartID: token,
    },
});
exports.generateAdobeAnalyticsSetBasketToken = generateAdobeAnalyticsSetBasketToken;
const generateAdobeAnalyticsSetAddBundleToBasketEvent = (data) => {
    if (!!data && data.length > 1) {
        return {
            product: data,
        };
    }
    return null;
};
exports.generateAdobeAnalyticsSetAddBundleToBasketEvent = generateAdobeAnalyticsSetAddBundleToBasketEvent;
const generateDigitalPartnerEnrolmentDigitalDataObject = (action) => {
    let pageObject = {};
    const pageObjectGenerator = [
        {
            checker: AnalyticsActions_interfaces_1.isAnalyticsDigitalPartnerEnrolmentStart,
            ruleNameSuffix: 'click to login',
        },
        {
            checker: AnalyticsActions_interfaces_1.isAnalyticsDigitalPartnerEnrolmentAuthEmail,
            pageInfo: {
                pageID: `${action.payload.partner}:0:email`,
                pageType: 'dpe member flow',
            },
            ruleNameSuffix: 'flow page',
        },
        {
            checker: AnalyticsActions_interfaces_1.isAnalyticsDigitalPartnerEnrolmentAuthLogin,
            pageInfo: {
                pageID: `${action.payload.partner}:1:login`,
                pageType: 'dpe member flow',
            },
            ruleNameSuffix: 'flow page',
        },
        {
            checker: AnalyticsActions_interfaces_1.isAnalyticsDigitalPartnerEnrolmentAuthRegister,
            pageInfo: {
                pageID: `${action.payload.partner}:1b:register`,
                pageType: 'dpe member flow',
            },
            ruleNameSuffix: 'flow page',
        },
        {
            checker: AnalyticsActions_interfaces_1.isAnalyticsDigitalPartnerEnrolmentAuthPasswordForgotten,
            pageInfo: {
                pageID: `${action.payload.partner}:1c:password_forgotten`,
                pageType: 'dpe member flow',
            },
            ruleNameSuffix: 'flow page',
        },
        {
            checker: AnalyticsActions_interfaces_1.isAnalyticsDigitalPartnerEnrolmentEligibilityCheck,
            pageInfo: {
                pageID: `${action.payload.partner}:2:active advantage`,
                pageType: 'dpe member flow',
            },
            ruleNameSuffix: 'flow page',
        },
        {
            checker: AnalyticsActions_interfaces_1.isAnalyticsDigitalPartnerEnrolmentConfirmation,
            pageInfo: {
                pageID: `${action.payload.partner}:3:confirmation`,
                pageType: 'dpe member flow',
            },
            ruleNameSuffix: 'flow page',
        },
        {
            checker: AnalyticsActions_interfaces_1.isAnalyticsDigitalPartnerEnrolmentLeave,
            pageInfo: {
                pageID: `${action.payload.partner}:leave`,
                pageType: 'dpe member flow',
            },
            ruleNameSuffix: 'leave page',
        },
    ];
    const selectedPageObjectGenerator = pageObjectGenerator.find(item => item.checker(action));
    if (selectedPageObjectGenerator) {
        pageObject = Object.assign(Object.assign({}, pageObject), { page: Object.assign(Object.assign({}, pageObject.page), { pageInfo: Object.assign({}, selectedPageObjectGenerator.pageInfo) }), event: [
                {
                    eventInfo: {
                        directCallRule: true,
                        ruleName: `${action.payload.partner.toString()}:${selectedPageObjectGenerator.ruleNameSuffix}`,
                        eventAction: '',
                    },
                },
            ] });
    }
    return pageObject;
};
exports.generateDigitalPartnerEnrolmentDigitalDataObject = generateDigitalPartnerEnrolmentDigitalDataObject;
const generateFormErrorMessageDigitalDataObject = (errorMessage) => {
    let pageObject = null;
    const errorMessageFields = Object.keys(errorMessage);
    if (errorMessageFields.length > 0) {
        pageObject = {
            page: {
                attributes: {
                    errorMessageForms: errorMessageFields.map(field => `${field}:${errorMessage[field]}`).join('|'),
                },
            },
            event: [
                {
                    eventInfo: {
                        directCallRule: true,
                        ruleName: AnalyticsEnums_1.DirectCallRules.ERROR_MESSAGE,
                        eventAction: '',
                    },
                },
            ],
        };
    }
    return pageObject;
};
exports.generateFormErrorMessageDigitalDataObject = generateFormErrorMessageDigitalDataObject;
const getDeliveryPromiseForProduct = (product) => {
    if (product.deliveryPromise && product.deliveryPromise.deliveryPromises.length > 0) {
        const currentDate = new Date();
        const deliveryMinInMS = (0, DateUtil_1.calculateDifferenceInMs)(product.deliveryPromise.deliveryDateFrom, currentDate);
        const deliveryMinInDays = Math.ceil((0, DateUtil_1.convertMillisecondsToDays)(deliveryMinInMS));
        const deliveryMaxInMS = (0, DateUtil_1.calculateDifferenceInMs)(product.deliveryPromise.deliveryDateTo, currentDate);
        const deliveryMaxInDays = Math.ceil((0, DateUtil_1.convertMillisecondsToDays)(deliveryMaxInMS));
        return {
            deliveryMinDays: deliveryMinInDays,
            deliveryMaxDays: deliveryMaxInDays,
            deliveryPromises: product.deliveryPromise.deliveryPromises,
        };
    }
    return undefined;
};
const getPriceViewModelForProduct = (selectedColor, selectedSize) => {
    let price = undefined;
    if (selectedColor) {
        price = selectedColor.prices;
        if (selectedSize) {
            price = selectedSize.prices;
        }
    }
    return price;
};
const getExpertReviewForProduct = (product, reviews) => {
    const selectedReview = reviews.find(item => +item.colorId === product.selectedColorId && item.productCode === product.productCode);
    return selectedReview
        ? selectedReview
        : reviews.find(item => item.productCode === product.productCode && !item.colorId);
};
const generatePossibleProductDiscount = (selectedColor, selectedSize) => {
    let discountPercentage = undefined;
    if (selectedColor) {
        discountPercentage = selectedColor.colourDiscountPercentage;
        if (selectedSize) {
            discountPercentage = selectedSize.productDiscountPercentage;
        }
    }
    return discountPercentage;
};
const generateAdobeAnalyticsProduct = (product, options) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { expertReviews, pdpTemplateName, sizeGuideAvailabilityState, sizeGuideViewedSate, bundleProductType, inANutshellAvailability, additionalProductBundle, } = options;
    const selectedColor = getSelectedColorForProduct(product);
    const selectedSize = getSelectedSizeForProduct(product);
    const activeProductPrice = getPriceViewModelForProduct(selectedColor, selectedSize);
    const deliveryPromiseInfo = getDeliveryPromiseForProduct(product);
    const productData = {
        attributes: Object.assign(Object.assign({}, (additionalProductBundle && { additionalProductBundle })), { sellPrice: (_a = activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.SELL) === null || _a === void 0 ? void 0 : _a.original, RRPSTD: (activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.RRP)
                ? activeProductPrice.RRP.original
                : (activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.STD)
                    ? activeProductPrice.STD.original
                    : (activeProductPrice === null || activeProductPrice === void 0 ? void 0 : activeProductPrice.SELL)
                        ? activeProductPrice.SELL.original
                        : undefined, productPriceOverlay: (_b = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.priceOverlay) === null || _b === void 0 ? void 0 : _b.overlayCode, productQualifier: product.productQualifier, brandValue: product.brandQualifier, buyingGroup: product.buyingGroup, gender: product.gender, brand: (_c = product.brand) === null || _c === void 0 ? void 0 : _c.description, productRating: (_d = product.productReview) === null || _d === void 0 ? void 0 : _d.avgScore, productReviews: (_e = product.productReview) === null || _e === void 0 ? void 0 : _e.numberOfScores, productDiscountPercentage: generatePossibleProductDiscount(selectedColor, selectedSize), productImages: ((_f = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.images) === null || _f === void 0 ? void 0 : _f.length) || 0, lastPieces: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.lastPieces) || false }),
        productInfo: {
            productID: product.productId,
            colorId: product.selectedColorId,
            color: selectedColor.translations.description,
            size: selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.originalSize,
            colorCode: selectedColor.colorCode,
        },
        deliveryPromiseInfo,
    };
    if (inANutshellAvailability) {
        productData.attributes.inANutshellFeatures = inANutshellAvailability;
    }
    if (expertReviews === null || expertReviews === void 0 ? void 0 : expertReviews.length) {
        const review = getExpertReviewForProduct(product, expertReviews);
        if (review) {
            productData.productInfo.expertReview = true;
        }
    }
    if (pdpTemplateName) {
        productData.attributes.productTemplate = pdpTemplateName;
    }
    if (sizeGuideAvailabilityState) {
        productData.attributes.sizeTable = sizeGuideAvailabilityState;
    }
    if (sizeGuideViewedSate) {
        productData.attributes.productSizeTable = sizeGuideViewedSate;
    }
    if (product.pdpVersion === common_types_1.PDPVersion.V2) {
        productData.attributes.excludeHomeDelivery = ((_g = product.fulfillment) === null || _g === void 0 ? void 0 : _g.hdExcluded)
            ? common_types_1.ProductExcluded.HD_EXCLUDED
            : common_types_1.ProductExcluded.HD_NOT_EXCLUDED;
        productData.attributes.excludeClickAndCollect = ((_h = product.fulfillment) === null || _h === void 0 ? void 0 : _h.ccExcluded)
            ? common_types_1.ProductExcluded.CC_EXCLUDED
            : common_types_1.ProductExcluded.CC_NOT_EXCLUDED;
        productData.attributes.excludeStoreSourcing = (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.storeSourceExcluded)
            ? common_types_1.ProductExcluded.SS_EXCLUDED
            : common_types_1.ProductExcluded.SS_NOT_EXCLUDED;
        productData.attributes.ourPlanet = product.ourPlanet ? 'ourPlanet' : 'standard';
    }
    if (bundleProductType) {
        productData.attributes.bundleProductType = bundleProductType;
    }
    return productData;
};
const generateAdobeAnalyticsProductDetailImpression = (productState, directCallRule) => {
    var _a;
    return ({
        page: {
            pageInfo: {
                pageType: 'product',
            },
        },
        product: [generateAdobeAnalyticsProduct(productState.product, { expertReviews: (_a = productState.expertReview) === null || _a === void 0 ? void 0 : _a.reviews })],
        directCallRule: directCallRule,
    });
};
exports.generateAdobeAnalyticsProductDetailImpression = generateAdobeAnalyticsProductDetailImpression;
const generateAdobeAnalyticsCookieConsentTriggers = (consentSettings, directCallRule) => {
    const userData = {
        consent: {},
    };
    Object.keys(consentSettings).forEach((consentGroup) => {
        userData.consent[consentGroup] = consentSettings[consentGroup];
    });
    return {
        user: userData,
        directCallRule: directCallRule,
    };
};
exports.generateAdobeAnalyticsCookieConsentTriggers = generateAdobeAnalyticsCookieConsentTriggers;
const generateGoogleAnalyticsCookieConsentTriggers = (consentSettings) => {
    const googleData = {
        event: 'cookiesReady',
    };
    Object.keys(consentSettings).forEach((consentGroup) => {
        googleData[`userConsent${(0, common_utils_1.capitalize)(consentGroup)}`] = consentSettings[consentGroup];
    });
    return googleData;
};
exports.generateGoogleAnalyticsCookieConsentTriggers = generateGoogleAnalyticsCookieConsentTriggers;
const generateAdobeAnalyticsListerProductClick = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.LISTER_PRODUCT_CLICK,
});
exports.generateAdobeAnalyticsListerProductClick = generateAdobeAnalyticsListerProductClick;
const generateAdobeAnalyticsFredhopperSegment = (segment) => ({
    page: {
        attributes: {
            fredhopperSegment: segment,
        },
    },
});
exports.generateAdobeAnalyticsFredhopperSegment = generateAdobeAnalyticsFredhopperSegment;
const generateAdobeAnalyticsWishlistEvent = (action, prevState) => {
    var _a;
    const { isPDP, isWishlistPage, product: currentProduct } = action.payload;
    const isMainPDPProduct = isPDP
        ? Number(prevState.product.productId) === currentProduct.productId
        : false;
    let directCallRule = '';
    let product;
    let productData;
    if (action.type === ActionEnums_1.WishListActionTypes.ANALYTICS_ADD) {
        directCallRule = AnalyticsEnums_1.DirectCallRules.WISHLIST_ADD;
    }
    else if (isPDP && isMainPDPProduct && action.type === ActionEnums_1.WishListActionTypes.ANALYTICS_REMOVE) {
        directCallRule = AnalyticsEnums_1.DirectCallRules.WISHLIST_REMOVE_PDP;
    }
    else if (isWishlistPage && action.type === ActionEnums_1.WishListActionTypes.ANALYTICS_REMOVE) {
        directCallRule = AnalyticsEnums_1.DirectCallRules.WISHLIST_REMOVE_WLIST;
    }
    else {
        directCallRule = AnalyticsEnums_1.DirectCallRules.WISHLIST_REMOVE;
    }
    if (isPDP && isMainPDPProduct) {
        product = prevState.product;
    }
    else if (isWishlistPage && prevState.wishList.items) {
        product = prevState.wishList.items.find((item) => item.productId === currentProduct.productId && item.colourId === currentProduct.colorId);
    }
    else if ('lister' in prevState && prevState.lister.items) {
        product = prevState.lister.items.find(item => 'productId' in item && item.productId === currentProduct.productId && item.colourId === currentProduct.colorId);
    }
    if (product) {
        productData = [
            {
                attributes: {
                    brand: isPDP ? (_a = product.brand) === null || _a === void 0 ? void 0 : _a.description : product.brand,
                    brandValue: '',
                    buyingGroup: isPDP ? product.buyingGroup : '',
                    gender: isPDP ? product.gender : product.genderCode,
                    productQualifier: isPDP ? product.productQualifier : '',
                },
                productInfo: {
                    productID: product.productId,
                },
            },
        ];
    }
    else {
        productData = [
            {
                productInfo: {
                    productID: currentProduct.productId,
                    colorCode: currentProduct.colorCode || '',
                    color: currentProduct.color || '',
                },
            },
        ];
    }
    return {
        product: productData,
        directCallRule,
    };
};
exports.generateAdobeAnalyticsWishlistEvent = generateAdobeAnalyticsWishlistEvent;
const generateAdobeAnalyticsCompareEvent = (actionType, payload) => {
    let directCallRule = undefined;
    const { product, sourceComponent } = payload;
    switch (actionType) {
        case ActionEnums_1.CompareActionTypes.COMPARE_ADD:
            if (sourceComponent === CompareConstants_1.COMPARE_TRIGGERED_COMPONENT.productDetail ||
                sourceComponent === CompareConstants_1.COMPARE_TRIGGERED_COMPONENT.productLister ||
                sourceComponent === CompareConstants_1.COMPARE_TRIGGERED_COMPONENT.productCompareBox) {
                directCallRule = AnalyticsEnums_1.DirectCallRules.COMPARE_ADD;
            }
            break;
        case ActionEnums_1.CompareActionTypes.COMPARE_REMOVE:
            switch (sourceComponent) {
                case CompareConstants_1.COMPARE_TRIGGERED_COMPONENT.productDetail:
                    directCallRule = AnalyticsEnums_1.DirectCallRules.COMPARE_REMOVE_PDP;
                    break;
                case CompareConstants_1.COMPARE_TRIGGERED_COMPONENT.productLister:
                    directCallRule = AnalyticsEnums_1.DirectCallRules.COMPARE_REMOVE_LISTER;
                    break;
                case CompareConstants_1.COMPARE_TRIGGERED_COMPONENT.productCompareBox:
                    directCallRule = AnalyticsEnums_1.DirectCallRules.COMPARE_REMOVE_COMPARE_BOX;
                    break;
                case CompareConstants_1.COMPARE_TRIGGERED_COMPONENT.comparePage:
                    directCallRule = AnalyticsEnums_1.DirectCallRules.COMPARE_REMOVE_COMPARE_PAGE;
                    break;
                default:
                    break;
            }
            break;
    }
    let productData;
    if (product) {
        productData = [
            {
                attributes: {
                    brand: product.brand,
                    brandValue: product.brandValue || '',
                    buyingGroup: product.buyingGroup || '',
                    gender: product.gender || '',
                    productQualifier: product.productQualifier || '',
                },
                productInfo: {
                    productID: product.id,
                },
            },
        ];
    }
    if (productData) {
        return {
            directCallRule,
            product: productData,
        };
    }
    return {};
};
exports.generateAdobeAnalyticsCompareEvent = generateAdobeAnalyticsCompareEvent;
const generateAdobeAnalyticsOpenComparePage = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.COMPARE_PAGE_OPEN,
});
exports.generateAdobeAnalyticsOpenComparePage = generateAdobeAnalyticsOpenComparePage;
const generateAdobeAnalyticsComparePageNoProductDisplayed = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.COMPARE_PAGE_NO_PRODUCT_DISPLAYED,
});
exports.generateAdobeAnalyticsComparePageNoProductDisplayed = generateAdobeAnalyticsComparePageNoProductDisplayed;
const generateAdobeAnalyticsComparePageProductDisplayed = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.COMPARE_PAGE_PRODUCT_DISPLAYED,
});
exports.generateAdobeAnalyticsComparePageProductDisplayed = generateAdobeAnalyticsComparePageProductDisplayed;
const generateAdobeAnalyticsComparePageProductDisplayedToggle = (displayed) => displayed
    ? (0, exports.generateAdobeAnalyticsComparePageProductDisplayed)()
    : (0, exports.generateAdobeAnalyticsComparePageNoProductDisplayed)();
exports.generateAdobeAnalyticsComparePageProductDisplayedToggle = generateAdobeAnalyticsComparePageProductDisplayedToggle;
const generateAdobeAnalyticsOpenComparePopup = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.COMPARE_POPUP_OPEN,
});
exports.generateAdobeAnalyticsOpenComparePopup = generateAdobeAnalyticsOpenComparePopup;
const generateAdobeAnalyticsCloseComparePopup = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.COMPARE_POPUP_CLOSE,
});
exports.generateAdobeAnalyticsCloseComparePopup = generateAdobeAnalyticsCloseComparePopup;
const generateAdobeAnalyticsToggleComparePopup = (prevCompareState) => prevCompareState.collapsed ? (0, exports.generateAdobeAnalyticsOpenComparePopup)() : (0, exports.generateAdobeAnalyticsCloseComparePopup)();
exports.generateAdobeAnalyticsToggleComparePopup = generateAdobeAnalyticsToggleComparePopup;
const generateAdobeAnalyticsDeliveryPromiseEvent = (action, productState) => {
    let productEvent = (0, exports.generateAdobeAnalyticsProductDetailImpression)(productState, AnalyticsEnums_1.DirectCallRules.PRODUCT_SIZE_PICKED);
    if (action.payload.deliveryPromises) {
        const productDeliveryAndStock = action.payload.deliveryPromises
            .map(item => `${item.name}: ${item.deliveryMessage}`)
            .join(' | ');
        productEvent = (0, common_utils_1.mergeObjectDeep)(productEvent, {
            page: {
                attributes: {
                    productDeliveryAndStock,
                    stockLocation: action.payload.stockLocation,
                },
            },
            event: [
                {
                    eventInfo: {
                        ruleName: AnalyticsEnums_1.DirectCallRules.PRODUCT_SIZE_PICKED,
                        eventAction: AnalyticsEnums_1.DirectCallRules.PRODUCT_SIZE_PICKED,
                    },
                },
            ],
        });
    }
    return productEvent;
};
exports.generateAdobeAnalyticsDeliveryPromiseEvent = generateAdobeAnalyticsDeliveryPromiseEvent;
const generateAdobeAnalyticsSearchEventProduct = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.SUCCESSFUL_SEARCH_EVENT_PRODUCT,
});
exports.generateAdobeAnalyticsSearchEventProduct = generateAdobeAnalyticsSearchEventProduct;
const generateAdobeAnalyticsSetSearchTerm = (searchTerm) => {
    if (searchTerm && searchTerm !== '') {
        SessionStorageUtil_1.default.setItem(SearchConstants_1.NOTHING_FOUND_SESSION_KEY, '1');
        return {
            directCallRule: AnalyticsEnums_1.DirectCallRules.SUCCESSFUL_SEARCH_EVENT_ITEM,
            page: {
                pageInfo: {
                    onsiteSearch: searchTerm,
                },
            },
        };
    }
    return null;
};
exports.generateAdobeAnalyticsSetSearchTerm = generateAdobeAnalyticsSetSearchTerm;
const generateAdobeAnalyticsNewsletterSubscribeEvent = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.NEWSLETTER_OPT_IN,
    engagement: {
        newsletterType: 'email_newsletter',
    },
});
exports.generateAdobeAnalyticsNewsletterSubscribeEvent = generateAdobeAnalyticsNewsletterSubscribeEvent;
const generateAdobeAnalyticsSessionInitEvent = (action) => {
    if (userIsLoggedInHelper(action)) {
        return {
            user: {
                attributes: {
                    loginStatus: true,
                    loginType: 'known user',
                },
                profileInfo: {
                    profileID: action.amcUuid,
                },
            },
        };
    }
    else {
        return {
            user: {
                attributes: {
                    loginStatus: false,
                    loginType: 'guest',
                },
            },
        };
    }
};
exports.generateAdobeAnalyticsSessionInitEvent = generateAdobeAnalyticsSessionInitEvent;
const generateAdobeAnalyticsSearchResultItemsCount = (count) => ({
    page: {
        pageInfo: {
            itemCount: count,
        },
    },
});
exports.generateAdobeAnalyticsSearchResultItemsCount = generateAdobeAnalyticsSearchResultItemsCount;
const generateAdobeAnalyticsSearchPasses = (searchPass) => ({
    page: {
        pageInfo: {
            searchPass,
        },
    },
});
exports.generateAdobeAnalyticsSearchPasses = generateAdobeAnalyticsSearchPasses;
const generateAdobeAnalyticsPaymentRequest = (paymentRequest) => ({
    transaction: {
        total: {
            selectedPaymentGroup: paymentRequest.paymentGroup,
            selectedPaymentMethod: paymentRequest.paymentMethod,
        },
    },
});
exports.generateAdobeAnalyticsPaymentRequest = generateAdobeAnalyticsPaymentRequest;
const generateAdobeAnalyticsConfirmationPage = () => ({
    page: {
        pageInfo: {
            pageID: 'confirmation',
        },
    },
});
exports.generateAdobeAnalyticsConfirmationPage = generateAdobeAnalyticsConfirmationPage;
const generateAdobeAnalyticsCheckout = (pageID, directCallRule) => {
    const pageData = {
        pageInfo: {
            pageID,
        },
    };
    return {
        page: pageData,
        directCallRule,
    };
};
exports.generateAdobeAnalyticsCheckout = generateAdobeAnalyticsCheckout;
const getCheckoutStep = (step, option = '') => ({
    event: 'checkout',
    ecommerce: {
        checkout: {
            actionField: {
                step,
                option,
            },
        },
    },
});
const getCheckoutOption = (step, option = '') => ({
    event: 'checkoutOption',
    ecommerce: {
        checkout_option: {
            actionField: {
                step,
                option,
            },
        },
    },
});
const generateGoogleAnalyticsDeliveryStep = (option = '') => getCheckoutStep(3, option); // delivery step -> 3
exports.generateGoogleAnalyticsDeliveryStep = generateGoogleAnalyticsDeliveryStep;
const generateGoogleAnalyticsDeliveryStepOption = (option = '') => getCheckoutOption(3, option); // delivery step -> 3
exports.generateGoogleAnalyticsDeliveryStepOption = generateGoogleAnalyticsDeliveryStepOption;
const generateGoogleAnalyticsPaymentStep = (option = '') => getCheckoutStep(4, option); // payment step -> 4
exports.generateGoogleAnalyticsPaymentStep = generateGoogleAnalyticsPaymentStep;
const generateGoogleAnalyticsPaymentStepOption = (option = '') => getCheckoutOption(4, option); // payment step -> 4
exports.generateGoogleAnalyticsPaymentStepOption = generateGoogleAnalyticsPaymentStepOption;
const generateAdobeAnalyticsRegistrationStep = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.CHECKOUT,
    page: { pageInfo: { pageID: AnalyticsEnums_1.PageId.REGISTRATION } },
});
exports.generateAdobeAnalyticsRegistrationStep = generateAdobeAnalyticsRegistrationStep;
const generateAdobeAnalyticsDeliveryStep = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.CHECKOUT,
    page: { pageInfo: { pageID: AnalyticsEnums_1.PageId.DELIVERY } },
});
exports.generateAdobeAnalyticsDeliveryStep = generateAdobeAnalyticsDeliveryStep;
const generateAdobeAnalyticsPaymentStep = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.CHECKOUT,
    page: { pageInfo: { pageID: AnalyticsEnums_1.PageId.PAYMENT } },
});
exports.generateAdobeAnalyticsPaymentStep = generateAdobeAnalyticsPaymentStep;
const generateAdobeAnalyticsFastCheckoutStep = () => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.CHECKOUT,
    page: { pageInfo: { pageID: AnalyticsEnums_1.PageId.FAST_CHECKOUT } },
});
exports.generateAdobeAnalyticsFastCheckoutStep = generateAdobeAnalyticsFastCheckoutStep;
const generateAdobeAnalyticsVoucherAdded = (code) => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.VOUCHER_ADDED,
    digitalData: { transaction: { attributes: { promoCode: code } } },
});
exports.generateAdobeAnalyticsVoucherAdded = generateAdobeAnalyticsVoucherAdded;
/* This method is deprecated and should not be used anymore when setting up new analytics events */
const generateAdobeAnalyticsEventObject = (ruleName, eventAction) => ({
    event: [
        {
            eventInfo: Object.assign({ directCallRule: true, ruleName }, (eventAction ? { eventAction } : {})),
        },
    ],
});
exports.generateAdobeAnalyticsEventObject = generateAdobeAnalyticsEventObject;
const generateAdobeAnalyticsEventObjectV2 = (ruleName, eventAction) => ({
    directCallRule: ruleName,
    event: [
        {
            eventInfo: {
                eventAction,
            },
        },
    ],
});
exports.generateAdobeAnalyticsEventObjectV2 = generateAdobeAnalyticsEventObjectV2;
const generateAdobeAnalyticsFilterWizardEvent = (eventAction, directCallRule, filterWizardCategory) => (Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObject)(directCallRule, eventAction)), { tools: {
        filterWizardCategory,
    } }));
exports.generateAdobeAnalyticsFilterWizardEvent = generateAdobeAnalyticsFilterWizardEvent;
const generateAdobeAnalyticsCheckoutType = (checkoutType) => ({
    transaction: { checkoutType },
});
exports.generateAdobeAnalyticsCheckoutType = generateAdobeAnalyticsCheckoutType;
const generateAdobeAnalyticsCompareProductsFeatures = (products) => ({
    product: products.map(product => ({
        attributes: {
            nbrComparisonFeatures: product.featuresAmount,
        },
        productInfo: {
            productID: product.id,
        },
    })),
});
exports.generateAdobeAnalyticsCompareProductsFeatures = generateAdobeAnalyticsCompareProductsFeatures;
const generateAdobeAnalyticsProductSearchPersonalization = (analyticsData) => ({
    page: {
        pageInfo: {
            personalizedSearch: analyticsData.personalized,
            personalizedSearchAttributes: analyticsData.traits,
        },
    },
});
exports.generateAdobeAnalyticsProductSearchPersonalization = generateAdobeAnalyticsProductSearchPersonalization;
const generateAdobeAnalyticsShopTheLook = (name) => (Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.SHOP_THE_LOOK)), { component: {
        componentInfo: {
            shopTheLook: name,
        },
    } }));
exports.generateAdobeAnalyticsShopTheLook = generateAdobeAnalyticsShopTheLook;
const generateAdobeAnalyticsListerSortChangeEvent = (sortValue) => (Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.LISTER_SORT_BY, AnalyticsEnums_1.EventActions.LISTER_SORT_BY)), { page: {
        attributes: {
            sortByFilterValue: sortValue,
        },
    } }));
exports.generateAdobeAnalyticsListerSortChangeEvent = generateAdobeAnalyticsListerSortChangeEvent;
const generateAdobeAnalyticsNewsletterPreferencesSubscriptionUpdateEvent = (optInSubscriptionTypes, optOutSubscriptionTypes) => {
    const digitalData = {
        directCallRule: AnalyticsEnums_1.DirectCallRules.NEWSLETTER_UPDATE_SUBSCRIPTIONS,
        engagement: {},
    };
    if (optInSubscriptionTypes) {
        digitalData.engagement = { newsletterOptIn: objectToString(optInSubscriptionTypes) };
    }
    if (optOutSubscriptionTypes) {
        digitalData.engagement = Object.assign(Object.assign({}, digitalData.engagement), { newsletterOptOut: objectToString(optOutSubscriptionTypes) });
    }
    return digitalData;
};
exports.generateAdobeAnalyticsNewsletterPreferencesSubscriptionUpdateEvent = generateAdobeAnalyticsNewsletterPreferencesSubscriptionUpdateEvent;
const generateAdobeAnalyticsNewsletterPreferencesUpdateEvent = (preferences, directCallRule) => ({
    directCallRule,
    engagement: {
        newsletterType: directCallRule === AnalyticsEnums_1.DirectCallRules.NEWSLETTER_PREFERENCES
            ? subscriptionsObjectToString(preferences)
            : objectToString(preferences),
    },
});
exports.generateAdobeAnalyticsNewsletterPreferencesUpdateEvent = generateAdobeAnalyticsNewsletterPreferencesUpdateEvent;
const generateAdobeAnalyticsReturnPortalLogin = (loginType) => (Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.RETURN_PORTAL_LOGIN, AnalyticsEnums_1.ReturnPortalEventActionType.LOGIN)), { user: {
        attributes: {
            loginType,
        },
    }, page: {
        pageInfo: {
            pageID: AnalyticsEnums_1.PageId.RETURN_PORTAL_LOGIN,
        },
    } }));
exports.generateAdobeAnalyticsReturnPortalLogin = generateAdobeAnalyticsReturnPortalLogin;
const generateAdobeAnalyticsReturnPortalOverview = (hasItems) => (0, common_utils_1.isNullOrUndefined)(hasItems)
    ? {
        directCallRule: AnalyticsEnums_1.DirectCallRules.RETURN_PRODUCT_OVERVIEW,
        page: { pageInfo: { pageID: AnalyticsEnums_1.PageId.RETURN_PORTAL_ANNOUNCED_RETURNS } },
    }
    : {
        directCallRule: AnalyticsEnums_1.DirectCallRules.RETURN_PRODUCT_OVERVIEW,
        page: {
            attributes: {
                returnProducts: hasItems ? 'available products' : 'no products available',
            },
            pageInfo: { pageID: AnalyticsEnums_1.PageId.RETURN_PORTAL_RETURN_PRODUCTS },
        },
    };
exports.generateAdobeAnalyticsReturnPortalOverview = generateAdobeAnalyticsReturnPortalOverview;
const generateAdobeAnalyticsReturnPortalEvent = (ruleName, pageID, eventAction, returnMethod) => {
    const dataObj = eventAction
        ? {
            event: [
                {
                    eventInfo: {
                        directCallRule: true,
                        ruleName,
                        eventAction,
                    },
                },
            ],
            page: { pageInfo: { pageID } },
        }
        : {
            directCallRule: ruleName,
            page: { pageInfo: { pageID } },
        };
    if (returnMethod) {
        (0, formik_1.setIn)(dataObj, 'page.attributes.returnMethod', returnMethod);
    }
    return dataObj;
};
exports.generateAdobeAnalyticsReturnPortalEvent = generateAdobeAnalyticsReturnPortalEvent;
const generateAdobeAnalyticsShowStoreStock = (productState) => {
    var _a, _b;
    return Object.assign(Object.assign({}, (!(0, common_utils_1.isNullOrUndefined)(productState.product) &&
        !(0, common_utils_1.isNullOrUndefined)((_a = productState.product) === null || _a === void 0 ? void 0 : _a.productColorVariations) && {
        product: [
            generateAdobeAnalyticsProduct(productState.product, { expertReviews: (_b = productState.expertReview) === null || _b === void 0 ? void 0 : _b.reviews }),
        ],
    })), (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.SHOW_STORE_STOCK, AnalyticsEnums_1.EventActions.SHOW_STORE_STOCK));
};
exports.generateAdobeAnalyticsShowStoreStock = generateAdobeAnalyticsShowStoreStock;
const generateAdobeAnalyticsProductDetailTabOpen = (tabTitle, pdpTemplateName, productState) => (Object.assign({ product: [
        generateAdobeAnalyticsProduct(productState.product, {
            expertReviews: productState.product.expertReviews,
            pdpTemplateName,
        }),
    ], page: {
        pageInfo: {
            productInformation: tabTitle,
        },
    } }, (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.PRODUCT_DETAIL_TAB_OPEN, AnalyticsEnums_1.EventActions.PRODUCT_DETAIL_TAB_OPEN)));
exports.generateAdobeAnalyticsProductDetailTabOpen = generateAdobeAnalyticsProductDetailTabOpen;
const generateAdobeAnalyticsProductDetailInit = (productDetailState, { pdpVersion, pdpTemplateName, hasSizeTable, productInformation, inANutshellAvailability, } = {}) => {
    const mainProduct = generateAdobeAnalyticsProduct(productDetailState.product, {
        expertReviews: productDetailState.product.expertReviews,
        pdpTemplateName,
        sizeGuideAvailabilityState: hasSizeTable
            ? common_types_1.AnalyticsSizeGuideAvailabilityTypes.AVAILABLE
            : common_types_1.AnalyticsSizeGuideAvailabilityTypes.NOT_AVAILABLE,
        inANutshellAvailability,
    });
    return pdpVersion === common_types_1.PDPVersion.V2
        ? {
            product: [mainProduct],
            mainProduct,
            page: {
                pageInfo: {
                    productInformation: productInformation,
                },
            },
            directCallRule: AnalyticsEnums_1.DirectCallRules.PRODUCT_VIEW,
        }
        : (0, exports.generateAdobeAnalyticsProductDetailImpression)(productDetailState, AnalyticsEnums_1.DirectCallRules.PRODUCT_VIEW);
};
exports.generateAdobeAnalyticsProductDetailInit = generateAdobeAnalyticsProductDetailInit;
const generateAdobeAnalyticsProductDetailSizeGuideClick = (product, pdpTemplateName) => (Object.assign({ product: [generateAdobeAnalyticsProduct(product, { pdpTemplateName })] }, (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.PRODUCT_DETAIL_SIZE_GUIDE_CLICK, AnalyticsEnums_1.EventActions.PRODUCT_DETAIL_SIZE_GUIDE_CLICK)));
exports.generateAdobeAnalyticsProductDetailSizeGuideClick = generateAdobeAnalyticsProductDetailSizeGuideClick;
const generateAdobeAnalyticsProductDetailAddToBasket = ({ product }, { analyticsAdobeTagManagerData, additionalProducts: additionalProductsData, }) => {
    var _a, _b, _c, _d;
    const analyticsData = (0, exports.generateAdobeAnalyticsBasketChangeEvent)(analyticsAdobeTagManagerData);
    const ruleName = analyticsData.event[0].eventInfo.ruleName;
    const isProductBundlesAdded = ((_a = analyticsData.page.attributes) === null || _a === void 0 ? void 0 : _a.addCardLocation) === ActionEnums_1.ProductAddToBasketLocations.PRODUCT_BUNDLES ||
        ((_b = analyticsData.page.attributes) === null || _b === void 0 ? void 0 : _b.addCardLocation) === ActionEnums_1.ProductAddToBasketLocations.PRODUCT_BUNDLES_MONETATE;
    const bundleProducts = isProductBundlesAdded
        ? generateAdobeAnalyticsBundleProductList(product.bundles[product.selectedColorId].bundleSlots)
        : undefined;
    const additionalProducts = additionalProductsData
        ? (0, exports.generateAdobeAnalyticsAdditionalProductList)(additionalProductsData)
        : undefined;
    const mainProduct = analyticsData.product.shift() || {};
    const mainProductData = (0, common_utils_1.mergeObjectDeep)(generateAdobeAnalyticsProduct(product, {
        expertReviews: product.expertReviews,
        sizeGuideViewedSate: product.sizeGuideViewed
            ? common_types_1.AnalyticsSizeGuideViewedTypes.VIEWED
            : common_types_1.AnalyticsSizeGuideViewedTypes.NOT_VIEWED,
        bundleProductType: bundleProducts ? 'Main' : undefined,
        additionalProductBundle: additionalProducts ? 'Main' : undefined,
    }), mainProduct);
    const bundleProductData = analyticsData.product.map(tmpProduct => {
        const linkedBundleProduct = bundleProducts === null || bundleProducts === void 0 ? void 0 : bundleProducts.find(item => parseInt(tmpProduct.productInfo.productID, 10) === item.productInfo.productID);
        return linkedBundleProduct
            ? (0, common_utils_1.mergeObjectDeep)(tmpProduct, {
                attributes: {
                    bundleProductType: linkedBundleProduct.attributes.bundleProductType,
                },
            })
            : tmpProduct;
    });
    const productData = [mainProductData, ...bundleProductData];
    return Object.assign(Object.assign({}, analyticsData), { product: productData, mainProduct: mainProductData, additionalProduct: additionalProducts
            ? analyticsData.product
                .map(tmpProduct => {
                const linkedAdditionalProduct = additionalProducts === null || additionalProducts === void 0 ? void 0 : additionalProducts.find(item => parseInt(tmpProduct.productInfo.productID, 10) === item.productInfo.productID);
                return linkedAdditionalProduct
                    ? (0, common_utils_1.mergeObjectDeep)(tmpProduct, {
                        attributes: Object.assign({}, (linkedAdditionalProduct && {
                            additionalProductBundle: linkedAdditionalProduct.attributes.additionalProductBundle,
                        })),
                    })
                    : undefined;
            })
                .filter(Boolean)
            : [], bundleProduct: bundleProducts
            ? analyticsData.product
                .map(tmpProduct => {
                const linkedBundleProduct = bundleProducts === null || bundleProducts === void 0 ? void 0 : bundleProducts.find(item => parseInt(tmpProduct.productInfo.productID, 10) === item.productInfo.productID);
                return linkedBundleProduct
                    ? (0, common_utils_1.mergeObjectDeep)(tmpProduct, {
                        attributes: {
                            bundleProductType: linkedBundleProduct.attributes.bundleProductType,
                        },
                    })
                    : undefined;
            })
                .filter(Boolean)
            : [], event: [
            {
                eventInfo: {
                    directCallRule: true,
                    ruleName,
                    eventAction: ruleName === AnalyticsEnums_1.DirectCallRules.SC_OPEN
                        ? AnalyticsEnums_1.EventActions.PRODUCT_DETAIL_ADD_TO_EMPTY_BASKET
                        : AnalyticsEnums_1.EventActions.PRODUCT_DETAIL_ADD_TO_BASKET,
                },
            },
        ], page: {
            attributes: Object.assign(Object.assign({}, (Boolean((_c = analyticsData.page) === null || _c === void 0 ? void 0 : _c.attributes) && analyticsData.page.attributes)), { addCardLocation: isProductBundlesAdded
                    ? (_d = analyticsData.page.attributes) === null || _d === void 0 ? void 0 : _d.addCardLocation
                    : ActionEnums_1.ProductAddToBasketLocations.PRODUCT_PAGE }),
        } });
};
exports.generateAdobeAnalyticsProductDetailAddToBasket = generateAdobeAnalyticsProductDetailAddToBasket;
const generateAdobeAnalyticsListerResults = (itemCount) => (Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.PRODUCT_LIST_PAGE)), { page: {
        pageInfo: {
            itemCount,
        },
    } }));
exports.generateAdobeAnalyticsListerResults = generateAdobeAnalyticsListerResults;
const generateGoogleAnalyticsListerViewProductListEvent = ({ items, event, currency, searchTerm, }) => (Object.assign(Object.assign({ event }, (Boolean(searchTerm) && event === AnalyticsEnums_1.Events.VIEW_SEARCH_RESULTS && { search_term: searchTerm })), { ecommerce: {
        currencyCode: (0, common_utils_1.getCurrencyISOCode)(currency),
        impressions: convertListerItemToProductImpression(items, { withQuantity: true, withPosition: true }),
    } }));
exports.generateGoogleAnalyticsListerViewProductListEvent = generateGoogleAnalyticsListerViewProductListEvent;
const generateGoogleCustomerIdentityAction = (identity, customerInfo) => (Object.assign({ event: 'custIdentify', visIdentity: identity }, (customerInfo && { custInfo: customerInfo })));
exports.generateGoogleCustomerIdentityAction = generateGoogleCustomerIdentityAction;
const generateAdobeAnalyticsBundleDealsViewedObject = (product, colorId) => ({
    product: [
        generateAdobeAnalyticsProduct(product, {
            expertReviews: product.expertReviews,
            bundleProductType: 'Main',
        }),
        ...generateAdobeAnalyticsBundleProductList(product.bundles[colorId].bundleSlots),
    ],
    mainProduct: generateAdobeAnalyticsProduct(product, {
        expertReviews: product.expertReviews,
        bundleProductType: 'Main',
    }),
    bundleProduct: generateAdobeAnalyticsBundleProductList(product.bundles[colorId].bundleSlots),
    event: [
        {
            eventInfo: {
                eventAction: AnalyticsEnums_1.EventActions.PRODUCT_BUNDLE_VIEW,
            },
        },
    ],
    directCallRule: AnalyticsEnums_1.DirectCallRules.BUNDLE_DEALS_VIEW,
});
exports.generateAdobeAnalyticsBundleDealsViewedObject = generateAdobeAnalyticsBundleDealsViewedObject;
const generateAdobeAnalyticsNotifyMeObject = (product) => (Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.NOTIFY_ME, AnalyticsEnums_1.EventActions.NOTIFY_ME)), { product: [generateAdobeAnalyticsProduct(product, {})] }));
exports.generateAdobeAnalyticsNotifyMeObject = generateAdobeAnalyticsNotifyMeObject;
const generateAdobeAnalyticsFaqQuestionExpand = (title) => (Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.FAQ_QUESTION_EXPAND, AnalyticsEnums_1.EventActions.FAQ_QUESTION_CLICK_OPEN)), { page: {
        pageInfo: {
            faqQuestion: title,
        },
    } }));
exports.generateAdobeAnalyticsFaqQuestionExpand = generateAdobeAnalyticsFaqQuestionExpand;
const generateGoogleAnalyticsPaybackEnrichmentChanged = ({ hasChanged, }) => ({
    event: 'shoppingbudget',
    actionField: 'success',
    label: hasChanged ? 'withenrichment' : 'withoutenrichment',
});
exports.generateGoogleAnalyticsPaybackEnrichmentChanged = generateGoogleAnalyticsPaybackEnrichmentChanged;
const generateAdobeAnalyticsEnrichmentChanged = ({ hasChanged, }) => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.SHOPPING_BUDGET,
    page: {
        attributes: {
            enrichmentState: hasChanged ? 'withenrichment' : 'withoutenrichment',
        },
    },
});
exports.generateAdobeAnalyticsEnrichmentChanged = generateAdobeAnalyticsEnrichmentChanged;
const generateGoogleAnalyticsPaybackError = ({ analyticsError }) => ({
    event: 'shoppingbudget',
    actionField: 'nosuccess',
    label: analyticsError,
});
exports.generateGoogleAnalyticsPaybackError = generateGoogleAnalyticsPaybackError;
const generateAdobeAnalyticsPaybackError = ({ analyticsError }) => ({
    directCallRule: AnalyticsEnums_1.DirectCallRules.SHOPPING_BUDGET,
    page: {
        attributes: {
            errorMessage: analyticsError,
        },
    },
});
exports.generateAdobeAnalyticsPaybackError = generateAdobeAnalyticsPaybackError;
const generateAdobeAnalyticsProductGroupViewed = ({ componentName, componentType, products, }) => (Object.assign(Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.PRODUCT_GROUP_VIEWED, AnalyticsEnums_1.EventActions.PRODUCT_GROUP_VIEWED)), (products.length
    ? { product: products.map((product, index) => generateProductGroupImpression(product, index + 1)) }
    : {})), { component: {
        componentInfo: {
            componentName,
            componentType,
        },
    } }));
exports.generateAdobeAnalyticsProductGroupViewed = generateAdobeAnalyticsProductGroupViewed;
const generateAdobeAnalyticsProductGroupItemClick = ({ componentName, componentType, productTilePosition, product, }) => (Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.PRODUCT_GROUP_ITEM_CLICK, AnalyticsEnums_1.EventActions.PRODUCT_GROUP_ITEM_CLICK)), { product: [generateProductGroupImpression(product, productTilePosition)], component: {
        componentInfo: {
            componentName,
            componentType,
        },
    } }));
exports.generateAdobeAnalyticsProductGroupItemClick = generateAdobeAnalyticsProductGroupItemClick;
const generateAdobeAnalyticsProductVariantClick = () => (0, exports.generateAdobeAnalyticsEventObject)(AnalyticsEnums_1.DirectCallRules.PRODUCT_VARIANT_CLICK, AnalyticsEnums_1.EventActions.PRODUCT_VARIANT_CLICK);
exports.generateAdobeAnalyticsProductVariantClick = generateAdobeAnalyticsProductVariantClick;
const generateAdobeAnalyticApplePayButtonInitialInViewport = (payload) => ({
    component: payload,
});
exports.generateAdobeAnalyticApplePayButtonInitialInViewport = generateAdobeAnalyticApplePayButtonInitialInViewport;
const generateAdobeAnalyticApplePayButtonImpression = (payload) => (Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObjectV2)(AnalyticsEnums_1.DirectCallRules.APPLE_PAY_BUTTON_IMPRESSION, AnalyticsEnums_1.EventActions.APPLE_PAY_BUTTON_IMPRESSION)), { component: payload }));
exports.generateAdobeAnalyticApplePayButtonImpression = generateAdobeAnalyticApplePayButtonImpression;
const generateAdobeAnalyticsGiftVoucherInit = (product) => ({
    product: [generateAdobeAnalyticsProduct(product, {})],
    directCallRule: AnalyticsEnums_1.DirectCallRules.PRODUCT_VIEW,
});
exports.generateAdobeAnalyticsGiftVoucherInit = generateAdobeAnalyticsGiftVoucherInit;
const generateBasketReminderNotificationViewed = () => (Object.assign({}, (0, exports.generateAdobeAnalyticsEventObjectV2)(AnalyticsEnums_1.DirectCallRules.BASKET_REMINDER_NOTIFICATION_VIEW, AnalyticsEnums_1.EventActions.BASKET_REMINDER_NOTIFICATION_VIEW)));
exports.generateBasketReminderNotificationViewed = generateBasketReminderNotificationViewed;
const generateBasketReminderNotificationEvent = (payload) => (Object.assign({}, (0, exports.generateAdobeAnalyticsEventObjectV2)(AnalyticsEnums_1.DirectCallRules.BASKET_REMINDER_NOTIFICATION_CLICK, payload)));
exports.generateBasketReminderNotificationEvent = generateBasketReminderNotificationEvent;
const generateAdobeAnalyticsAdditionalProductSelector = (payload, productDetailState) => (Object.assign(Object.assign({}, (0, exports.generateAdobeAnalyticsEventObjectV2)(AnalyticsEnums_1.DirectCallRules.ADDITIONAL_PRODUCT_SELECTOR_VIEW, AnalyticsEnums_1.EventActions.ADDITIONAL_PRODUCT_SELECTOR_VIEW)), { mainProduct: generateAdobeAnalyticsProduct(productDetailState.product, {
        expertReviews: productDetailState.product.expertReviews,
    }), additionalProduct: (0, exports.generateAdobeAnalyticsAdditionalProductList)(payload) }));
exports.generateAdobeAnalyticsAdditionalProductSelector = generateAdobeAnalyticsAdditionalProductSelector;
